import { Component, ViewChild, ViewEncapsulation, Input, OnDestroy } from '@angular/core';
import { DispatchesService } from '../shared/services/dispatches.service';
import { GlobalsService } from '../shared/services/globals.service';
import { GItem } from '../shared/models/GItem';
import { CustomerService } from '../shared/services/customer.service';
import { DropDownListComponent } from '@progress/kendo-angular-dropdowns';
import { DispatchSearch } from '../shared/DispatchSearch';
import { v_DispatchGrid2Bus } from '../shared/models/v_DispatchGrid2Bus';
import { Subscription } from 'rxjs';
import { PageChangeEvent, SelectableSettings, SelectionEvent } from '@progress/kendo-angular-grid';
import { DQOIComponent } from '../dqoi/dqoi.component';
import { DQOIReferenceDataQuery } from '../dqoi/state/dqoi-reference-data.query';
import { CommonFunctions } from '../shared/static/common-functions';
import { SearchTarget } from '../shared/enums/SearchTarget';
import { WindowContents } from '../shared/enums/windowContents';
import { DispatchData } from '../shared/models/DispatchData';
import { MSCLFilterClass } from '../shared/classes/filters/MSCLFilterClass';
import { BaseGridUIComponent } from '../shared/base-components/base-grid-ui.component';
import { DispatchSearchType } from '../shared/enums/dispatchSearchType';
import { DomSanitizer } from '@angular/platform-browser';
import { GridComponent } from "@progress/kendo-angular-grid";
import * as _ from 'lodash';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
    selector: 'dispatch-history-search',
    templateUrl: './dispatch-history-search.component.html',
    styleUrls: ['./dispatch-history-search.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class DispatchHistorySearchComponent extends BaseGridUIComponent<v_DispatchGrid2Bus, null, DispatchesService> implements OnDestroy  {

    dispatchStatusNameCF: MSCLFilterClass;
    locationNameCF: MSCLFilterClass;
    priorityNameCF: MSCLFilterClass;
    featureFlagSet: any = {};

    constructor(svc_data: DispatchesService, globals: GlobalsService, private svc_cust: CustomerService, private qry_rd: DQOIReferenceDataQuery, private sanitizer: DomSanitizer, private activatedRoute: ActivatedRoute) {
        super(globals);
        this.pageSize = 200;
        this.svc_data = svc_data;
        this.qry_rd.ensureRefDataIsLoaded(this.globals.companyId).subscribe();
        this.getRouteParams();
    }
    // Dynamic parameters for this component's route: /example-params/:first/:second
    routeParams: Params;

    // Query parameters found in the URL: /example-params/one/two?query1=one&query2=two
    queryParams: Params;
    getRouteParams() {

        // Route parameters
        this.activatedRoute.params.subscribe(params => {
            this.routeParams = params;
        });

        // URL query parameters
        this.activatedRoute.queryParams.subscribe(params => {
            this.queryParams = params;
        });
    }
    @Input() customerIdInput?: any;
    @Input() locationIdInput?: any;
    subs_dataRef: Subscription;
    @ViewChild("dqoi") _dqoi: DQOIComponent;
    dqoi: DQOIComponent;
    @ViewChild("listboxType") listboxType: DropDownListComponent;
    detailOpened: boolean = false;
    subs_data: Subscription;
    subs_data_custCBO: Subscription;
    subs_data_locCBO: Subscription;
    data_customersCBO: GItem[] = [];
    data_locationsCBO: GItem[] = [];
    filtereddata_LocationCBOs: GItem[];
    public selectableSettings: SelectableSettings;
    activeLocsOnly: boolean = true;

    public setSelectableSettings(): void {
        this.selectableSettings = {
            checkboxOnly: false,
            mode: "single"
        };
    }
    serviceConstruction: GItem[] = [
        //    { "description": "", "value":"", "category":"" },
        { "description": "All Dispatches & Jobs", "value": "A", "category": "", "reference": null },
        { "description": "Service Dispatches Only", "value": "S", "category": "", "reference": null },
        { "description": "Construction Dispatches Only", "value": "C", "category": "", "reference": null }
    ]
    selected_customer: GItem;
    selected_location: GItem;
    selected_type: GItem;
    selected_type_value: string = "S";
    default_type: GItem = { "description": "Service Dispatches Only", "value": "S", "category": "", "reference": null };
    search_note: string;
    openStatusesOnly: boolean = true;

    logo: any;
    get hasLogo(): boolean {
        return CommonFunctions.hasValue(this.logo);
    }

    ngOnInit() {
        CommonFunctions.unsubscribe(this.subs_data_custCBO);
        this.subs_data_custCBO = this.svc_cust.getCustomersForCBO().subscribe(data => {

            this.data_customersCBO = data
            if (this.customerIdInput && this.locationIdInput) {
                this.selected_customer = this.data_customersCBO.find(o => o.value === this.customerIdInput);
                this.customerCBOChanged(this.selected_customer);
            }
            else {

                if (this.routeParams && this.routeParams.customerId) {
                    this.selected_customer = this.data_customersCBO.find(o => o.value === this.routeParams.customerId);
                    this.customerCBOChanged(this.selected_customer);
                }

            }
        });
    }

    override ngOnDestroy() {
        super.ngOnDestroy();
        if (this.subs_data_custCBO) {
            this.subs_data_custCBO.unsubscribe();
        }
        if (this.subs_data_locCBO) {
            this.subs_data_locCBO.unsubscribe();
        }
        CommonFunctions.unsubscribe(this.subs_data);
    }

    activeLocsOnlyChanged(e: any) {
        this.activeLocsOnly = e;
        if (this.activeLocsOnly) {
            this.filtereddata_LocationCBOs = this.data_locationsCBO.filter(t => t.canSelect === true);
        }
        else {
            this.filtereddata_LocationCBOs = _.cloneDeep(this.data_locationsCBO);
        }
    }

    searchGrid() {
        this.gridData = null;
        this.skip = 0;
        this.getData();
    }
    getData() {
        this.dataLoading = true;
        let search: DispatchSearch = new DispatchSearch();

        search.customerId = this.selected_customer.value;
        search.locationId = (this.selected_location !== undefined && this.selected_location !== null) ? this.selected_location.value : "";
        search.openStatusesOnly = this.openStatusesOnly;
        search.isActive = this.activeLocsOnly;
        search.type = DispatchSearchType.all;
        if (this.selected_type_value === "S") {
            search.type = DispatchSearchType.service;
        }
        else if (this.selected_type_value === "C") {
            search.type = DispatchSearchType.construction;
        }
        search.skip = this.skip;
        search.note = this.search_note;
        this.subs_data = this.svc_data.SearchHistory(search).subscribe(data => {
            this.ListData = data.resultList;
            this.grid.editRow(0);
            this.dataLoading = false;;
            this.getLogo(this.selected_customer.value);
        });
    }

    getLogo(customerId: string) {
        this.logo = null;
        this.svc_cust.getLogo(customerId).subscribe(blob => {
            this.logo = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob));
        });
    }

    pageChange(e: PageChangeEvent) {
        this.getData();
        if (this.selected_location !== undefined && this.selected_location !== null) {

        }
        else {

        }
    }
    searchServer() {

    }
    filterClear() {
        this.selectedData = null;
        this.gridData = null;
        this.selected_customer = null;
        this.selected_location = null;
    }
    customerCBOChanged(e: GItem) {

        this.selected_customer = e;
        this.selected_location = null;
        CommonFunctions.unsubscribe(this.subs_data_locCBO);
        this.subs_data_locCBO = this.svc_cust.getCustomerLocationsForCBO(e.value).subscribe(data => {
            this.data_locationsCBO = data;
            this.activeLocsOnlyChanged(this.activeLocsOnly);

            if (this.customerIdInput && this.locationIdInput) {
                this.selected_location = this.data_locationsCBO.find(o => o.value === this.locationIdInput);

                this.searchGrid();
            }

            if (this.routeParams && this.routeParams.locationId) {
                this.selected_location = this.data_locationsCBO.find(o => o.value === this.routeParams.locationId);
                this.routeParams = null;
                this.searchGrid();
            }

        })
    }
    locationCBOChanged(e: GItem) {
        this.selected_location = e;
    }
    typeCBOChanged(e: any) {
        this.selected_type_value = e;
    }
    openChanged(e: any) {
        this.openStatusesOnly = e;
    }
    allChanged(e: any) {
    }
    rowSelected(e: SelectionEvent) {
        this.selectedData = e.selectedRows[0].dataItem;
    }
    detailId: any;
    details(data: v_DispatchGrid2Bus) {
        console.log("dsh-details: ", data);

        let target: SearchTarget = SearchTarget.dispatch;
        if (data.isConstruction) {
            if (CommonFunctions.hasGuidValue(data.masterJobId)) {
                target = SearchTarget.job;
            }
            else {
                target = SearchTarget.contract;
            }
        }
        this.dqoiPopup(data.dispatchId, target, data.isConstruction);
    }
    closeDetail() {
        this.detailOpened = false;
    }
    detailsData: DispatchData;
    dqoiPopup(id: any, target: SearchTarget = SearchTarget.dispatch, isConstruction: boolean = false) {
        let data: DispatchData = new DispatchData();
        data.id = id;
        data.target = target;
        data.isConstruction = isConstruction;
        data.viewDispatch.dispatchId = id;
        console.log("dsh-dqoiPop: ", data);
        this.detailsData = data;
    }
    public cpActiveChildComp: number;
    public cpWindowData: any;
    public cpShowWindow: boolean = false;
    public cpContentTypes = WindowContents;
    cpPopWindow(injected: any) {
        this.cpActiveChildComp = injected.contentType;
        this.cpWindowData = injected.boardData;
        this.cpShowWindow = true;
    }
    onCPWindowClosed(e) {
        //        this.refreshData(DbTable.DispatchAssignments);
        this.cpShowWindow = false;
    }
    processGridData() {
        this.dispatchStatusNameCF = new MSCLFilterClass('dispatchStatusName', 'dispatchStatusName', this.gridData);
        this.locationNameCF = new MSCLFilterClass('locationName', 'locationName', this.gridData);
        this.priorityNameCF = new MSCLFilterClass('priorityName', 'priorityName', this.gridData);
        this.expandGrid();
    }
    @ViewChild(GridComponent) grid: GridComponent;

    expandGrid() {
        let length = this.gridData.length,
            element = null;
        for (let i = 0; i < length; i++) {
            element = this.gridData[i];
            this.grid.expandRow(i);
        }
    }

}
